import type { IStockRepository, AssetHistoryOptions, AssetHistoryPage, AssetHistoryPageOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListAssetHistoryUseCase({ stockRepository }: Deps) {
  return async function listAssetHistory(options: AssetHistoryOptions): Promise<StockTransactionEntity[]> {
    return stockRepository.listAssetHistory(options);
  };
}

export function createListAssetHistoryPageUseCase({ stockRepository }: Deps) {
  return async function listAssetHistoryPage(options: AssetHistoryPageOptions): Promise<AssetHistoryPage> {
    return stockRepository.listAssetHistoryPage(options);
  };
}
